export enum SettingsSharedActionsDataEventObjectsEnum {
  CREATE_NEW_SHARED_ACTION = 'create_new_shared_action',
  CREATE_SHARED_ACTION = 'create_shared_action',
  EDIT_SHARED_ACTION = 'edit_shared_action',
  LIST_SHARED_ACTIONS = 'list_shared_actions',
  DELETE_SHARED_ACTION = 'delete_shared_action',
}
